export const DEV_DETAILS_DIALOG_SCOPE_ID = 'devOpsSummary';

export const PACKAGE_NAME = 'jira.issue.dev-ops-summary';
export const TEAM_NAME = 'fusion-solaris';
